import { isStandalone } from '../../../constants';
import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';
import { getPhone } from './getPhone';

export const getViberSettings = ({ viberPhone }: Partial<ChatsChannelBase>) => {
  if (!viberPhone) return null;

  const isChat = /^viber:\/\/p[au]/.test(viberPhone);
  const url = isChat
    ? viberPhone
    : `viber://chat?number=${getPhone(viberPhone)}`;

  return {
    provider: ChatsChannelType.viber,
    link: { url, options: { openCurrentPage: true } },
    title: 'Viber',
    icon: getChatIcon(ChatsChannelType.viber),
    withCaption: true,
    color: isStandalone ? 'rgba(102, 184, 33, 1)' : 'rgba(104, 90, 176, 1)'
  } as ChatsChannelSetting;
};
